<template>
  <v-app-bar color="primary" dark app elevate-on-scroll style="z-index: 99">
    <!-- <v-app-bar-nav-icon @click="handleDrawerToggle" /> -->

    <v-toolbar color="primary" elevation="0">
      <img
        class="top-logo"
        :src="computeLogoIcon"
        height="90%"
        alt="RC Turtas"
        @click="gotoHome()"
      />
      <v-toolbar-title class="app-title ml-0 pl-3" @click="gotoHome()">
        <span class="hidden-sm-and-down">{{ appTitle }}</span>
      </v-toolbar-title>
      <img class="app-mark" :src="appMark" height="100%" alt="" />
    </v-toolbar>

    <v-spacer />
    <v-toolbar-items>
      <!-- <v-btn v-if="showSavitarna" icon @click="changeNeigalieji()" class="mr-5"
        >Neig</v-btn
      >
      <v-btn v-if="showSavitarna" icon @click="changeHost()" class="mr-5"
        >Savitarna</v-btn
      > -->
      <v-btn icon @click="gotoZinute()">
        <v-badge color="green" :content="zinuteAktyvi" :value="zinuteAktyvi">
          <v-icon>mdi-message-text-outline</v-icon>
          <!-- <v-icon>mdi-message-reply-text-outline</v-icon> -->
        </v-badge>
      </v-btn>
      <!-- <v-btn icon @click="handleFullScreen()">
        <v-icon>mdi-fullscreen</v-icon>
      </v-btn> -->

      <v-menu offset-y origin="center center" transition="scale-transition">
        <template v-slot:activator="{ on }">
          <v-btn text slot="activator" v-on="on">
            {{ getUsername }}
          </v-btn>
        </template>
        <v-list class="pa-0">
          <v-list-item
            v-for="(item, index) in profileMenus"
            :to="!item.href ? { name: item.name } : null"
            :href="item.href"
            @click="item.click"
            :disabled="item.disabled"
            :target="item.target"
            rel="noopener"
            :key="index"
          >
            <v-list-item-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
    <template v-slot:extension>
      <app-top-menu :dark="false" />
    </template>
    <modal-profile v-model="showProfile" />
  </v-app-bar>
</template>
<script>
import AppTopMenu from './AppTopMenu'
import Util from '@/util'
import { mapGetters } from 'vuex'
import userRole from '../../../mixins/userRole'
import ModalProfile from '../../modals/ModalProfile'
import { Neigalieji } from '../../../assets/neigalieji.js'

export default {
  name: 'AppToolbar',
  components: {
    AppTopMenu,
    ModalProfile,
  },
  mixins: [userRole],
  data() {
    return {
      profileMenus: [
        {
          icon: 'mdi-account',
          href: '',
          title: 'Profilis',
          click: this.handleProfile,
        },
        {
          icon: 'mdi-power',
          href: '',
          title: 'Atsijungti',
          click: this.handleLogut,
        },
      ],
      showProfile: false,
    }
  },
  computed: {
    ...mapGetters(['getAvatar', 'getUsername', 'userID', 'zinuteAktyvi']),
    computeLogoIcon() {
      return '/static/turtas_icon_color.png'
    },
    availableLanguages() {
      const { locales } = this.$vuetify.lang
      return Object.keys(locales).map(lang => {
        return {
          text: locales[lang].label,
          value: lang,
        }
      })
    },
    localeText() {
      const find = this.availableLanguages.find(
        item => item.value === this.$vuetify.lang.current
      )
      return find.text
    },
    appMark() {
      if (process.env.VUE_APP_LOCAL === 'develop') {
        return '/static/dev-mark2.png'
      }
      if (process.env.VUE_APP_LOCAL === 'test') {
        return '/static/test-mark2.png'
      }
      if (process.env.VUE_APP_PREPROD === 'true') {
        return '/static/preprod-mark.png'
      }
      return null
    },
    showSavitarna() {
      return (
        process.env.VUE_APP_LOCAL === 'local' ||
        process.env.VUE_APP_LOCAL === 'develop'
      )
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    isDevelop() {
      return process.env.VUE_APP_LOCAL === 'develop'
    },
    isTest() {
      return process.env.VUE_APP_LOCAL === 'test'
    },
  },
  methods: {
    handleDrawerToggle() {
      this.$emit('side-icon-click')
    },
    handleFullScreen() {
      Util.toggleFullScreen()
    },
    handleLogut() {
      // if (window.confirm('Ar norite atsijungti?')) {
      this.$store.dispatch('logout').then(() => {
        window._VMA.$emit('SHOW_SNACKBAR', {
          text: 'Atsijungta sėkmingai',
          color: 'success',
        })
        this.$router.push({ name: 'login' })
      })
      // }
    },
    handleChangeLocale({ value }) {
      this.$vuetify.lang.current = value
    },
    handleSetting() {},
    handleProfile() {
      this.showProfile = true
    },
    handleGoBack() {
      this.$router.go(-1)
    },
    gotoHome() {
      if (this.roleRGV) {
        this.$router.push({ name: 'zurnalasGaunami' })
      } else {
        this.$router.push({ name: 'home' })
      }
    },
    changeHost() {
      window.location.href = process.env.VUE_APP_SAVITARNA_URL
      // sessionStorage.setItem('isSavitarna', true)
      // this.$axios
      //   .post(`fakesavitarna/${this.userID}`, {})
      //   .then(res => {
      //     this.$store.dispatch('fakeSavitarna').then(() => {
      //       this.$router.push({ name: 'home' })
      //       location.reload()
      //     })
      //   })
      //   .catch(err => {
      //     window._VMA.$emit('DATA_ERROR', err.response.data.message)
      //   })
    },
    changeNeigalieji() {
      Neigalieji()
    },
    gotoZinute() {
      this.$router.push({ name: 'zinutes' })
    },
  },
}
</script>

<style lang="scss" scoped>
.top-logo,
.app-title {
  cursor: pointer;
}
.top-logo {
  margin-left: 0px;
}
</style>
